import { StyleSheet } from "react-native";
import { Colors } from "react-native-paper";
import { appColors } from "../../../assets/styles/global";
import { pixelDimensions } from "../../../config/utils";

const styles = StyleSheet.create({
    content: {
        alignItems: "center",
        flex: 1,
        justifyContent: "center"
    },
    imageCoinBank: {
        height: pixelDimensions(50), 
        width: pixelDimensions(50)*79/83
    },
    textBalance: {
        color: Colors.white,
        paddingHorizontal: pixelDimensions(8),
        fontSize: pixelDimensions(6)
    },
    textBalanceNumber: {
        color: Colors.white,
        fontSize: pixelDimensions(10)
    },
    viewCoinBalance: {
        backgroundColor: appColors.primary,
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: pixelDimensions(2),
        marginVertical: pixelDimensions(4),
    },
    viewCoinSubBalance: {
        borderLeftColor: Colors.white,
        borderLeftWidth: 2,
        alignItems: "center"
    },
    viewBase: {
        flex: 1,
        backgroundColor: Colors.grey300
    },
})

export default styles;